export const createQueryObjectFromURL = (url: string) => {
  const params = new URLSearchParams(url);
  const query: Record<string, unknown> = {};
  params.forEach((value, key) => {
    query[key] = query[key] || key === 'ms' ? params.getAll(key) : value;
  });
  return query;
};
